import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import {
  ICommonServiceProps,
  IGlobalMetaSchema,
} from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { IIcApiConfigResponseSchema } from "./icApiConfiguratorApi.types";

const useGetAllIcApiConfiguratorServices = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  filters,
}: ICommonServiceProps) => {
  const [searchIcApiConfigQuery, setSearchIcApiConfigQuery] =
    useState<string>("");

  const { debouncedQuery } = useGlobalDebounceHandler(searchIcApiConfigQuery);
  const getAllicApiConfiguratorService = useQuery<{
    data: IIcApiConfigResponseSchema[];
    meta: IGlobalMetaSchema;
  }>({
    queryKey: [...CACHE_KEYS.IC_API_CONFIG, page, per_page, debouncedQuery],

    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.IC_API_CONFIG,
        searchParams: {
          "filter[product_name]": debouncedQuery,
          page,
          per_page,
          ...filters,
        },
      }),

    enabled: enableQuery,
  });

  return {
    services: { getAllicApiConfiguratorService },
    states: { searchIcApiConfigQuery, setSearchIcApiConfigQuery },
  };
};

const useGetSingleIcApiConfiguratorService = ({
  icApiConfigId,
}: {
  icApiConfigId: string;
}) => {
  return useQuery<{
    data: IIcApiConfigResponseSchema;
  }>({
    queryKey: [...CACHE_KEYS.IC_API_CONFIG, icApiConfigId],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.IC_API_CONFIG}/${icApiConfigId}`,
      }),
    enabled: !!icApiConfigId,
  });
};

export {
  useGetAllIcApiConfiguratorServices,
  useGetSingleIcApiConfiguratorService,
};
